"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _SeatsPicker = _interopRequireDefault(require("../common/SeatsPicker"));

var _BundlePage = require("./BundlePage");

var _Terms = require("self-service-api/constants/Terms");

var _ServicePlanButton = _interopRequireDefault(require("./ServicePlanButton"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _AccordionTransition = _interopRequireDefault(require("UIComponents/transitions/AccordionTransition"));

var Editions = _interopRequireWildcard(require("self-service-api/constants/Editions"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _HubBundleHeader = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/HubBundleHeader"));

var _publicPageUrls = require("pricing-pages-unified-ui/utils/publicPageUrls");

var _MerchandiseSelectors = require("../../selectors/MerchandiseSelectors");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  overflow: visible !important;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ButtonFlex = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "ServiceHubBundle__ButtonFlex",
  componentId: "sc-1rfyazz-0"
})(_templateObject(), _responsiveBreakpoints.default.phone(_templateObject2()));

var ButtonWrapper = _styledComponents.default.div.withConfig({
  displayName: "ServiceHubBundle__ButtonWrapper",
  componentId: "sc-1rfyazz-1"
})(_templateObject3());

var StyledAccordionTransition = (0, _styledComponents.default)(_AccordionTransition.default).withConfig({
  displayName: "ServiceHubBundle__StyledAccordionTransition",
  componentId: "sc-1rfyazz-2"
})(_templateObject4());

function ServiceHubBundle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      setState = _useContext.setState;

  var merchandiseMap = (0, _reactRedux.useSelector)(_MerchandiseSelectors.merchandiseSelector);
  var servicePlanSelected = state.servicePlanSelected,
      serviceUnits = state.serviceUnits;
  return _react.default.createElement("div", {
    className: "m-bottom-12",
    "data-selenium-id": "service-hub-bundle-root",
    "data-merch-id": servicePlanSelected,
    "data-units": serviceUnits,
    "data-units-merch-id": servicePlanSelected && merchandiseMap[servicePlanSelected].additionalUnitMerchId
  }, _react.default.createElement(_HubBundleHeader.default, {
    title: title,
    subtitle: subtitle,
    hub: _Hubs.default.HUB_SERVICE,
    gaClassName: (0, _publicPageUrls.getGAClassName)('bundle-pricing-servicecompare')
  }), _react.default.createElement(ButtonFlex, {
    className: "m-top-6"
  }, _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(_ServicePlanButton.default, {
    edition: Editions.STARTER,
    merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_STARTER_MAR_2020
  })), _react.default.createElement(ButtonWrapper, {
    className: "m-right-2"
  }, _react.default.createElement(_ServicePlanButton.default, {
    edition: Editions.PROFESSIONAL,
    merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL
  })), _react.default.createElement(ButtonWrapper, null, _react.default.createElement(_ServicePlanButton.default, {
    edition: Editions.ENTERPRISE,
    merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE
  }))), _react.default.createElement(StyledAccordionTransition, {
    open: !!servicePlanSelected
  }, _react.default.createElement("div", {
    className: "m-top-10"
  }, _react.default.createElement(_SeatsPicker.default, {
    merchandiseId: servicePlanSelected,
    additionalUnitQuantity: serviceUnits,
    onChange: function onChange(value) {
      return setState({
        serviceUnits: value
      });
    },
    term: _Terms.MONTHLY
  }))));
}

var _default = ServiceHubBundle;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/ServiceHubBundle.js
// module id = 704
// module chunks = 5 6